import { Injector } from '../../classes/injector';
import React from 'react';

export const AngularDIContext = React.createContext<Injector>(null);
